import React from "react";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { IAppEntity } from "../../entities";
import FixedAssetsWriteOffsDetails from "../../../components/Pages/Documents/FixedAssetsWriteOffs/FixedAssetsWriteOffsDetails";
import FixedAssetsWriteOffsList from "../../../components/Pages/Documents/FixedAssetsWriteOffs/FixedAssetsWriteOffsList";
import { CreateFixedAssetsWriteOffDto } from "../../../dtos/documents/FixedAssetsWriteOff/CreateFixedAssetsWriteOffDto";
import { FixedAssetsWriteOffService } from "../../../services/documents/FixedAssetsWriteOffService";
import { NFLookupFixedAssetsWriteOffs } from "../../../components/Shared/NewForms/NFLookupFixedAssetsWriteOffs";

export const FixedAssetsWriteOffs: IAppEntity = {
  entityType: "document",
  title: "Fixed Assets Write Offs",
  pluralTitle: "FixedAssetsWriteOffs",
  apiUrl: "FixedAssetsWriteOffs",
  apiEnum: ReferenceTypes.DocumentFixedAssetsWriteOff,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(FixedAssetsWriteOffsDetails, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(FixedAssetsWriteOffsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupFixedAssetsWriteOffs, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new FixedAssetsWriteOffService("FixedAssetsWriteOffs"),
  getEmptyModel: () => {
    const model: CreateFixedAssetsWriteOffDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      
      documentDate: new Date(),
      createdDate: new Date(),
    };
    return model;
  },
};
